"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * IScoreGolfPlus Development
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 1.1.56-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TournamentLogToJSON = exports.TournamentLogFromJSONTyped = exports.TournamentLogFromJSON = void 0;
function TournamentLogFromJSON(json) {
    return TournamentLogFromJSONTyped(json, false);
}
exports.TournamentLogFromJSON = TournamentLogFromJSON;
function TournamentLogFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'time': json['time'],
        'description': json['description'],
    };
}
exports.TournamentLogFromJSONTyped = TournamentLogFromJSONTyped;
function TournamentLogToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'time': value.time,
        'description': value.description,
    };
}
exports.TournamentLogToJSON = TournamentLogToJSON;
